import { render, staticRenderFns } from "./PageDetailHeader.vue?vue&type=template&id=7a8f0e1e&scoped=true"
import script from "./PageDetailHeader.vue?vue&type=script&lang=js"
export * from "./PageDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./PageDetailHeader.vue?vue&type=style&index=0&id=7a8f0e1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8f0e1e",
  null
  
)

export default component.exports